import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { useMaster } from 'context/MasterContext';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（受付方法）
function AnalysisUkeType(props) {
  const master = useMaster();

  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = master.ukeType.map((x) => ({
    key: `UKE_${x.id}`,
    label: x.name,
  }));

  return (
    <AnalysisCategory
      analysisList={analysisList}
      selectedPeriod={selectedPeriod}
      summaryItems={summaryItems}
      analysisKind={analysisKind}
      comparisonKind={comparisonKind}
      categoryName="受付方法別"
    />
  );
}
export default AnalysisUkeType;
